import axios from '@/mod/axiosMod';

export default {
  getSlotList(params, headers) {
    return axios.post('/marketing/source/getPageSlotList', params, { headers });
  },
  reportSource(params) {
    return axios.post('/marketing/source/reportSource', params);
  },
};
